import { applyMiddleware, createStore } from 'redux';
import { thunk } from 'redux-thunk';
//Import root reducer-sum off all app reducers
import rootReducer from './rootReducer';

const Store = createStore(rootReducer, applyMiddleware(thunk));

export type RootStore = ReturnType<typeof rootReducer>;
export default Store;
